ITS WORKING

{{ markers | json }}
<!--TODO: We need a single map component-->
<!--<agm-map-->
<!--  #map-->
<!--  [latitude]="latitude"-->
<!--  [longitude]="longitude"-->
<!--  [zoom]="zoom"-->
<!--  [style.height]="height"-->
<!--&gt;-->
<!--  <ng-container *ngIf="markers?.length">-->
<!--    <ng-container *ngFor="let marker of markers">-->
<!--      <agm-marker-->
<!--        [iconUrl]="marker.icon || markerPlain"-->
<!--        [latitude]="marker.lat"-->
<!--        [longitude]="marker.long"-->
<!--      >-->
<!--        <agm-info-window #infoWindow>-->
<!--          {{ marker.label }}-->
<!--        </agm-info-window>-->
<!--      </agm-marker>-->

<!--      &lt;!&ndash; The radius in meters on the Earth's surface. &ndash;&gt;-->

<!--      <ng-container *ngIf="marker?.radius">-->
<!--        <agm-circle-->
<!--          [fillColor]="marker?.radius?.colour"-->
<!--          [latitude]="marker.lat"-->
<!--          [longitude]="marker.long"-->
<!--          [radius]="marker?.radius?.distance"-->
<!--        >-->
<!--        </agm-circle>-->
<!--      </ng-container>-->
<!--    </ng-container>-->
<!--  </ng-container>-->
<!--</agm-map>-->
